<template>
  <button class="ladda-button btn" :class="`btn-${type}`" @click.prevent="click" data-style="zoom-out"><span class="ladda-label"><slot></slot></span></button>
</template>

<script>
  
  import ladda from 'ladda'

  export default {
    props: {
      onClick: {
        required: true,
        type: Function
      },
      arguments: {
        required: false,
        type: Array,
        default () {
          return []
        }
      },
      type: {
        required: false,
        type: String,
        default: 'primary'
      },
      delay: {
        required: false,
        type: Number,
        default: 500
      }
    },

    data () {
      return {
        instance: null
      }
    },

    mounted () {
      this.instance = ladda.create(this.$el)
    },

    methods: {
      click () {
        this.instance.start()

        this.onClick(...this.arguments).then(this.stop).catch(this.stop)
      },

      stop () {
        setTimeout(this.instance.stop, this.delay)
      }
    }
  }
</script>